{
  "buttons": {
    "save": "Save",
    "cancel": "Cancel",
    "confirm": "Confirm {deleteText}",
    "delete": "Delete",
    "remove": "Remove",
    "edit": "Edit",
    "submit": "Submit",
    "close": "Close",
    "previous": "Previous",
    "next": "Next",
    "reset": "Reset",
    "back": "Back"
  },
  "navbar": {
    "skipToNavigation": "Skip to navigation",
    "cart": "Cart",
    "navigation": "Navigation"
  },
  "toast": {
    "genericError": "Something went wrong. Try again later or contact support.",
    "errorTitle": "Error",
    "successTitle": "Success",
    "saved": "{entity} saved!",
    "deleted": "{entity} deleted!",
    "warningTitle": "Attention"
  },
  "loading": "Loading...",
  "labels": {
    "yes": "Yes",
    "no": "No"
  },
  "table": {
    "actions": "Actions",
    "displayingEntries": "Displaying {from}–{to} of {total} entries",
    "oneEntry": "1 entry",
    "show": "Show"
  },
  "export": {
    "title": "Export {modelName}"
  }
}
